document.addEventListener('DOMContentLoaded', async (e) => {
  const factories = await getFactories();

  const markers = [];
  const input = document.getElementById('find-tree-project-input');
  const searchResults = document.getElementById('searchresults');
  const searchResultsOverlay = document.getElementById('searchresults-overlay');
  const results = document.getElementById('results');
  input.addEventListener('input', function (event) {
    const searchTerm = event.target.value;
    if (searchTerm.length === 0) {
      searchResults.classList.add('ec-hidden');
      searchResults.classList.remove('ec-block');
      searchResultsOverlay.classList.add('ec-hidden');
      searchResultsOverlay.classList.remove('ec-block');
    } else {
      const httpRequest = new XMLHttpRequest();
      httpRequest.onreadystatechange = async () => {
        if (httpRequest.readyState) {
          const response = JSON.parse(httpRequest.responseText).resources.results.products;
          if (response.length === 0) {
            searchResults.classList.add('ec-hidden');
            searchResults.classList.remove('ec-block');
            searchResultsOverlay.classList.add('ec-hidden');
            searchResultsOverlay.classList.remove('ec-block');
            return;
          } else {
            results.innerHTML = '';
            searchResults.classList.remove('ec-hidden');
            searchResults.classList.add('ec-block');
            searchResultsOverlay.classList.remove('ec-hidden');
            searchResultsOverlay.classList.add('ec-block');

            response.forEach((product) => {
              const li = document.createElement('li');
              li.data = product.handle;
              li.className =
                'ec-px-6 ec-py-2 ec-border-solid ec-border-0 ec-border-b ec-border-gray-light ec-list-none ec-flex ec-items-center ec-cursor-pointer';
              const img = document.createElement('img');
              img.className = 'ec-w-12 ec-h-12 ec-rounded ec-mr-4 ec-object-contain';
              img.src = `${product.image}&width=100`;
              const span = document.createElement('span');
              span.className = 'ec-text-gray-dark';
              span.innerHTML = product.title;
              li.appendChild(img);
              li.appendChild(span);
              addEventListener(li);
              results.appendChild(li);
            });
          }
        }
      };

      const query = `/search/suggest.json?q=${searchTerm}&resources[type]=product`;
      httpRequest.open('GET', query, true);
      httpRequest.send();
    }
  });

  const addEventListener = (li) => {
    li.addEventListener('click', async (e) => {
      if (e.currentTarget.data === undefined) return;
      const data = await getFactoryLiquidDetails(e.currentTarget.data);
      showProject(data.manufacturer, data.name);
    });
  };
  var myearth = new Earth('myearth', {
    location: { lat: 46.6, lng: 7.8 },
    mapLandColor: '#a5cb7b',
    mapSeaColor: '#bbe6e9',
  });

  myearth.addEventListener('ready', async function () {
    factories.forEach((factory, productName) => {
      if (!factory.gps) return;
      const [lat, lng] = factory.gps.split(',');
      const mymarker = myearth.addMarker({
        location: { lat: lat, lng: lng },
        mesh: ['Marker'],
        color: '#3a6a39',
        scale: 0.5,
        hotspot: true,
        hotspotRadius: 0.75,
        hotspotHeight: 1.3,
        factoryHandle: factory.handle,
      });
      markers.push(mymarker);
      mymarker.addEventListener('click', async (e) => {
        const factoryHandle = e.target.factoryHandle;
        clickMarker(e.target, markers);
        const manu = await getManufacturer(factoryHandle);

        showProject(manu);
      });
    });
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const factoryParam = urlParams.get('factory');
    if (factoryParam) {
      const foundMarker = markers.find((marker) => {
        return marker.factoryHandle === factoryParam;
      });
      clickMarker(foundMarker, markers);
      const manu = await getManufacturer(factoryParam);
      showProject(manu);
    } else {
      const factoryHandle = factories[0].handle;
      const foundMarker = markers.find((marker) => {
        return marker.factoryHandle === factoryHandle;
      });
      clickMarker(foundMarker, markers);
      const manu = await getManufacturer(factoryHandle);
      showProject(manu);
    }
  });
  const showProject = (factory, productName) => {
    // Globe
    if (factory.gps) {
      const [lat, lng] = factory.gps.split(',');
      const location = { lat: Number.parseFloat(lat), lng: Number.parseFloat(lng) };
      if (
        myearth.goTo(location, {
          relativeDuration: 100,
          approachAngle: 12,
          end: function () {
            auto_rotate = false;
          },
        })
      ) {
        auto_rotate = true;
      }
    }
    // Content

    document.getElementById('treetracker-region').innerHTML = factory.address;
    addPropertyOrHide('treetracker-region', factory?.address);

    const groupElement = document.getElementById('treetracker-product-group');

    groupElement.innerHTML = '';
    factory.product_groups?.forEach((productGroup, index) => {
      const span = document.createElement('span');
      span.className = 'ec-text-gray-dark';
      span.innerHTML = `${productGroup}${index === factory.product_groups.length - 1 ? '' : ','} `;
      groupElement.appendChild(span);
    });

    if (!factory.product_groups) {
      groupElement.parentElement.classList.add('ec-hidden');
    } else {
      groupElement.parentElement.classList.remove('ec-hidden');
    }
    console.log('factory', factory);

    // document.getElementById('treetracker-amount_employee').innerHTML = factory.amount_employee;

    addPropertyOrHide('treetracker-headline-desktop', factory?.name);
    addPropertyOrHide('treetracker-headline-mobile', factory?.name);
    addPropertyOrHide('treetracker-description-desktop', factory?.description);
    addPropertyOrHide('treetracker-description-mobile', factory?.description);
    addPropertyOrHide('treetracker-region', factory?.address);
    addPropertyOrHide('treetracker-amount_employee', factory?.amount_employee);
    addPropertyOrHide('treetracker-product-group', factory?.product_groups);
    addPropertyOrHide('treetracker-reports', factory?.reports, true, true);
    addPropertyOrHide('treetracker-certificates', factory?.certificates, true, true);

    searchResults.classList.add('ec-hidden');
    searchResults.classList.remove('ec-block');
    searchResultsOverlay.classList.add('ec-hidden');
    searchResultsOverlay.classList.remove('ec-block');
    if (productName) {
      input.value = productName;
    }

    if (factory.images !== '') {
      const images = factory.images.replaceAll(']', '').replaceAll('[', '').split(',');
      document.getElementsByClassName('dots')[0].innerHTML = '';

      const imageSlider = document.getElementsByClassName('nik-standard-slider')[0].getElementsByClassName('inner')[0];
      imageSlider.innerHTML = '';
      for (let i = 0; i < images.length; i++) {
        const image = document.createElement('img');
        image.src = images[i];
        image.className =
          'nik-standard-slider-slide ec-w-full ec-aspect-video ec-object-cover ec-rounded-md ec-mr-4 ec-snap-center';
        imageSlider.appendChild(image);
        document.getElementsByClassName('dots')[0].innerHTML += `<span class="dot ec-w-2 ec-h-2 ec-rounded-full ec-block ec-mr-2 ${i === 0 ? 'active' : ''}" `;="" }="" addSliderEventListender();="" let="" headline;="" if="" (window.innerWidth=""> 768) {
      headline = document.getElementById('treetracker-headline-desktop');
    } else {
      headline = document.getElementById('treetracker-headline-mobile');
    }
    // window.scrollTo({ top: headline.getBoundingClientRect().top - 100, behavior: 'smooth' });
  };
});

const addPropertyOrHide = (element, value, parent, href) => {
  try {
    const el = document.getElementById(element);

    if (value && !value.includes('files/?')) {
      if (href) {
        el.href = value;
      } else {
        el.innerHTML = value;
      }
      if (parent) {
        el.parentNode.classList.remove('ec-hidden');
      } else {
        el.classList.remove('ec-hidden');
      }
    } else {
      if (parent) {
        el.parentNode.classList.add('ec-hidden');
      } else {
        el.classList.add('ec-hidden');
      }
    }
  } catch (error) {
    console.log('error', error, element, value, parent);
  }
};

const clickMarker = (clickedMarker, markers) => {
  clickedMarker.color = '#ffffff';

  markers.forEach((marker) => {
    if (marker != clickedMarker) {
      marker.color = '#3a6a39';
    }
  });
};

const getManufacturer = async (factoryHandle) => {
  const query = `/products/treeshirt?view=manufacturer&handle=${factoryHandle}`;
  const res = await fetch(query);
  if (!res.ok) {
    return;
  }
  const data = await res.json();

  console.log('getManufacturer', data);

  return data.manufacturer;
};

const getFactories = async () => {
  try {
    const response = await fetch('https://nikinclothing-eu.myshopify.com/api/2023-07/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': 'f9556daad34afe91af82f12398167317',
      },
      body: JSON.stringify({
        query: '{\n  metaobjects(type: "factory_tracker", first:200) {edges {node {handle, fields {key value}}}}}',
      }),
    });
    if (response.ok) {
      const graphql = await response.json();
      const factories = graphql.data.metaobjects.edges.map((edge) => {
        const object = {
          handle: edge.node.handle,
        };
        edge.node.fields.map(({ key, value }) => {
          object[key] = value;
        });
        return object;
      });
      return factories;
    }
  } catch (error) {
    console.log('error', error);
  }
};

const getCurrentFactory = (factories) => {
  return factories[0];
};

const getFactoryLiquidDetails = async (handle) => {
  const res = await fetch(`/products/${handle}?view=product-manufacturer`);
  if (!res.ok) {
    return;
  }
  const data = await res.json();
  console.log('getFactoryLiquidDetails', data);

  return data;
};
</span>